import AuthLayout from "comps/AuthLayout";
import "../../App.css";

import WalletCore from "./walletCore";

const Wallet = () => {

  return (
    <AuthLayout name="Wallet">
		<WalletCore topUpVariant="info"  />
    </AuthLayout>
  );
};

export default Wallet;
